import React from 'react'
import { useController } from 'react-hook-form'

function isCheckboxChecked(fieldValue, checkedValue) {
	if (typeof checkedValue === 'boolean')
		return Boolean(fieldValue) === checkedValue && Boolean(fieldValue)

	if (checkedValue === 1)
		return fieldValue === 1 || fieldValue === '1' || fieldValue === true

	return fieldValue === checkedValue
}

function ShopifyFormCheckbox({
	name,
	control,
	type = 'checkbox',
	defaultValue = false,
	checkedValue = 1,
	uncheckedValue = 0,
	onChange,
	inputRef,
	...props
}) {
	const { field } = useController({
		name,
		control,
		defaultValue,
	})

	return (
		<input
			{...props}
			type={type}
			name={field.name}
			checked={isCheckboxChecked(field.value, checkedValue)}
			onBlur={field.onBlur}
			onChange={(event) => {
				field.onChange(event.target.checked ? checkedValue : uncheckedValue)
				if (onChange)
					onChange(event)
			}}
			ref={(node) => {
				field.ref(node)
				if (typeof inputRef === 'function')
					inputRef(node)
			}}
		/>
	)
}

export default ShopifyFormCheckbox